/* import */
import * as React from "react"
import { Link } from "gatsby"
import parse from "html-react-parser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

/* define */
const FeaturedArticle = props => {
  if (props?.url === undefined) {
    return
  }
  const image = getImage(props?.gatsbyImage)
  return (
    <Link to={props?.url || ""} className="card-link">
      <div className="card h-100">
        <div
          style={{
            gridArea: "1/1",
            position: "relative",
            placeItems: "center",
            display: "grid",
          }}
        >
          <div class="img_container">
              <img
                alt={props?.image.alt}
                className="img_thumbnail"
                src={props?.image?.sourceUrl}
                layout="fullWidth"
                formats={["auto", "webp", "avif"]}
              />
            </div>
        </div>
        <div className="card-body">
          <h3>{props?.name || ""}</h3>
          {/*
          <p className="card-text">{parse(props?.lead_in || "")}</p>
          */}
          <div className="read_more">Read More</div>
        </div>
      </div>
    </Link>
  )
}

/* export */
export default FeaturedArticle
